import classNames from 'classnames';
import Form from 'mcs-toolkit/components/Form';
import Radio from 'mcs-toolkit/components/Radio';
import React from 'react';

import { QuestionTooltip } from 'reactApp/components/questionTooltip/questionTooltip';
import IconCircleCheckmarkFilled from 'reactComponents/icons/circleCheckmarkFilled';

import css from './RadioGroup.css';

type RadioGroupOption = {
    value: string | number;
    label: string | React.ReactNode;
    disabled?: boolean;
    description?: string;
    icon?: any;
    dataTest?: string;
};
type OnChangeData = {
    value: string;
};
export type RadioGroupProps = {
    disabled?: boolean;
    options: RadioGroupOption[];
    className?: string;
    value?: string | number;
    name: string;
    onChange?: (
        event: React.SyntheticEvent<Element, Event>,
        data: OnChangeData,
        prevData?: OnChangeData,
    ) => void;
    type?: string;
    imageBlockClassName?: string;
    label?: string;
};
export class RadioGroup extends React.PureComponent<RadioGroupProps> {
    renderOption = (option: RadioGroupOption, index) => {
        const {
            className,
            value,
            name,
            onChange,
            disabled,
            imageBlockClassName = '',
            type,
        } = this.props;

        let label = option.label;
        const checked = value === option.value;
        if (type === 'images') {
            label = (
                <>
                    <div
                        className={classNames(
                            css.labelWithIconContainer,
                            {
                                [css.labelWithIconContainerChecked]: checked,
                            },
                            imageBlockClassName,
                        )}
                    >
                        {option.description &&
                            this.renderQuestionTooltip(option.description)}
                        {option.icon}
                        <div className={css.labelWithIcon}>{option.label}</div>
                    </div>
                    {checked && (
                        <IconCircleCheckmarkFilled
                            width="16"
                            height="16"
                            className={css.checkmark}
                        />
                    )}
                </>
            );
        }

        return (
            <div
                className={classNames(css.radioFieldWrapper, className)}
                key={index}
            >
                <Form.Field
                    data-test={option.dataTest}
                    className={css.radioField}
                    control={Radio}
                    name={name}
                    value={option.value}
                    label={label}
                    checked={checked}
                    onChange={onChange}
                    disabled={option.disabled || disabled}
                />
                {type !== 'images' &&
                    option.description &&
                    this.renderQuestionTooltip(option.description)}
            </div>
        );
    };

    renderQuestionTooltip(description: string) {
        return (
            <QuestionTooltip
                text={description}
                position="right center"
                triggerClassName={css.questionTooltip}
            />
        );
    }

    render() {
        const { options, type, label } = this.props;
        return (
            <div
                className={classNames(css.root, {
                    [css.inline]: type === 'inline',
                    [css.images]: type === 'images',
                })}
            >
                {label && <div className={css.label}>{label}</div>}
                <div className={css.optionsWrapper}>
                    {options.map(this.renderOption)}
                </div>
            </div>
        );
    }
}
